{
      "repositories" : [
    {
        "branch":  "preview",
        "url":  "https://gitlab.cs.nl/de-ijsmaker/de-ijsmaker-cdp/tree/783ef9f9ba820972cb6bab687782468e6fdc6715",
        "displayName":  "CDP",
        "tag":  "",
        "lastCommitHash":  "783ef9f9ba820972cb6bab687782468e6fdc6715"
    },
    {
        "branch":  "HEAD",
        "url":  "https://Teamcity_IJS@gitlab.cs.nl/cs/cohelion/pm-core/tree/ac8d6ab3c699f57d3d8595022db85441b13cf7ab",
        "displayName":  "pm-core",
        "tag":  "",
        "lastCommitHash":  "ac8d6ab3c699f57d3d8595022db85441b13cf7ab"
    },
    {
        "branch":  "HEAD",
        "url":  "https://Teamcity_IJS@gitlab.cs.nl/cs/performancemanager/performance-manager-seed/tree/c48506ba3eb833f102a2c3341937419d81edbdf5",
        "displayName":  "cdp-client",
        "tag":  "",
        "lastCommitHash":  "c48506ba3eb833f102a2c3341937419d81edbdf5"
    }
],
      "buildDate"	: "2026-10-05T16:46+0200",
    "detailsUrl"	: "http://teamcity/buildConfiguration/DeIJsmaker_Cdp_Client_Preview/95091?buildTab=changes&showFiles=false&expandRevisionsSection=false",
    "version": "7.19.0",
    "libs": {
    "@cs/about":  "1.2.0",
    "@cs/assistant":  "1.7.7"
}
  }